import { cbSemanticCssVars } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Typography } from 'common/typography';

import { CoverItem } from './types';
import { DroppableImageSlot } from '../ImageSlot/DroppableImageSlot';

export type CoversTabProps = {
  headerItems: CoverItem[];
  listItems: CoverItem[];
};

const Root = styled.div`
  padding: 8px 32px 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
  overflow: auto;
`;

const Description = styled(Typography.Body3)`
  color: ${cbSemanticCssVars.textSecondary};
  display: block;
  margin: 4px 0 20px;
`;

const ImageContainer = styled.div`
  width: 100%;
  aspect-ratio: 16 / 9;
`;

export const CoversTab = ({ headerItems: [firstHeaderItem], listItems: [firstListItem] }: CoversTabProps) => (
  <Root>
    <div>
      <Typography.Heading6>
        <FormattedMessage id="photo-shoot.covers.list-image.header" />
      </Typography.Heading6>
      <Description>
        <FormattedMessage id="photo-shoot.covers.list-image.description" />
      </Description>

      <ImageContainer>
        <DroppableImageSlot
          id={firstListItem.id}
          image={firstListItem.images[0]}
          isLoading={firstListItem.isLoading}
          isReadOnly={firstListItem.isReadOnly}
          data={{ id: firstListItem.id, images: firstListItem.images }}
          onUnlink={firstListItem.onUnlink}
        />
      </ImageContainer>
    </div>

    <div>
      <Typography.Heading6>
        <FormattedMessage id="photo-shoot.covers.menu-image.header" />
      </Typography.Heading6>
      <Description>
        <FormattedMessage id="photo-shoot.covers.menu-image.description" />
      </Description>

      <ImageContainer>
        <DroppableImageSlot
          id={firstHeaderItem.id}
          image={firstHeaderItem.images[0]}
          isLoading={firstHeaderItem.isLoading}
          isReadOnly={firstHeaderItem.isReadOnly}
          data={{ id: firstHeaderItem.id, images: firstHeaderItem.images }}
          onUnlink={firstHeaderItem.onUnlink}
        />
      </ImageContainer>
    </div>
  </Root>
);
